import { ResizePlugin } from './ResizePlugin';
import { extensions } from '@pixi/core';

extensions.add(ResizePlugin);

export * from './Application';
export { ResizePlugin };
